import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { TenantType } from 'src/types/enums';

export interface ICandidateState {

  showAvailabilityManagerModal: boolean;
  showCompanyInviteModal: boolean;
  showCandidateInviteModal: boolean;
  companyInviteTargetTenant?: TenantType;
  showCompanyInviteListModal: boolean;
  showCandidateInviteListModal: boolean;

  candidateEditorState: {
    open: boolean;
    candidateId?: string | null;
    firstName?: string;
    lastName?: string;
    email?: string;
  }

  fileImporterState: {
    open: boolean;
    organizationId?: string | null;
  };
}

const initialState: ICandidateState = {
  showAvailabilityManagerModal: false,
  showCompanyInviteModal: false,
  showCandidateInviteModal: false,
  companyInviteTargetTenant: undefined,

  showCompanyInviteListModal: false,
  showCandidateInviteListModal: false,

  candidateEditorState: {
    open: false,
    candidateId: null,
  },

  fileImporterState: {
    open: false,
    organizationId: null,
  }
};

export const candidateSlice = createSlice({
  name: 'candidate',
  initialState,
  reducers: {
    setAvailabilityManagerModalVisibility: (state, action: PayloadAction<{ status: boolean }>) => {
      state.showAvailabilityManagerModal = action.payload.status;
    },

    toggleCompanyInviteModal: (state, action: PayloadAction<{ status: boolean; targetTenant?: TenantType }>) => {
      state.showCompanyInviteModal = action.payload.status;
      state.companyInviteTargetTenant = action.payload.status ? action.payload.targetTenant : undefined;
    },

    toggleCompanyInviteListModal: (state, action: PayloadAction<{ status: boolean }>) => {
      state.showCompanyInviteListModal = action.payload.status;
    },

    toggleCandidateInviteListModal: (state, action: PayloadAction<{ status: boolean }>) => {
      state.showCandidateInviteListModal = action.payload.status;
    },

    toggleCandidateInviteModal: (state, action: PayloadAction<{ status: boolean }>) => {
      state.showCandidateInviteModal = action.payload.status;
    },

    toggleCandidateEditorSidesheet: (state, action: PayloadAction<{
      status: boolean,
      candidateId?: string | null,
      firstName?: string,
      lastName?: string,
      email?: string,
    }>) => {
      state.candidateEditorState.open = action.payload.status;
      state.candidateEditorState.candidateId = action.payload.status ? action.payload.candidateId : null;

      state.candidateEditorState.firstName = action.payload.status ? action.payload.firstName : undefined;
      state.candidateEditorState.lastName = action.payload.status ? action.payload.lastName : undefined;
      state.candidateEditorState.email = action.payload.status ? action.payload.email : undefined;
    },

    toggleCandidateFileImporterModal: (state, action: PayloadAction<{
      status: boolean,
      organizationId?: string | null,
    }>) => {
      state.fileImporterState!.open = action.payload.status;
      state.fileImporterState!.organizationId = action.payload.status ? action.payload.organizationId : null;
    }
  },
});

export const {
  setAvailabilityManagerModalVisibility,
  toggleCompanyInviteModal,
  toggleCompanyInviteListModal,
  toggleCandidateInviteModal,

  toggleCandidateInviteListModal,

  toggleCandidateEditorSidesheet,

  toggleCandidateFileImporterModal
} = candidateSlice.actions;

export const candidateeducer = candidateSlice.reducer;
